// Mimloo anchor scroll + scrollspy
(function () {
  var sections = {
    'about':            '__mimloo_feature_grid_1',
    'founding-members': '__mimloo_bg_multicolumn_rDxapD',
    'stay-connected':   '__mimloo_newsletter_1',
    'faqs': '__collapsible_content_fxECcG'
  };

  // --- Smooth scroll on nav click ---
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var key = link.hash && link.hash.slice(1);
    var suffix = sections[key];
    if (!suffix) return;

    e.preventDefault();

    var target = document.querySelector('[id$="' + suffix + '"]');
    if (!target) return;

    var targetDocTop = target.getBoundingClientRect().top + window.scrollY;
    var header = document.querySelector('.section-header');
    var headerHeight = header ? header.offsetHeight : 0;
    // Header hides on scroll-down, stays visible on scroll-up.
    // Only subtract header height when scrolling up (header will remain visible).
    var scrollingDown = targetDocTop > window.scrollY;
    var top = targetDocTop - (scrollingDown ? 0 : headerHeight);

    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  // --- Scrollspy ---
  function getNavLink(key) {
    return document.querySelector('.header__inline-menu a[href$="#' + key + '"]');
  }

  function setActive(activeKey) {
    Object.keys(sections).forEach(function (key) {
      var link = getNavLink(key);
      if (!link) return;
      link.classList.toggle('mimloo-nav-active', key === activeKey);
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var header = document.querySelector('.section-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var triggerY = window.scrollY + headerHeight + 10;

      var activeKey = null;
      Object.keys(sections).forEach(function (key) {
        var el = document.querySelector('[id$="' + sections[key] + '"]');
        if (!el) return;
        if (triggerY >= el.offsetTop && triggerY < el.offsetTop + el.offsetHeight) {
          activeKey = key;
        }
      });

      setActive(activeKey);
      ticking = false;
    });
  }, { passive: true });

})();
